<template>
  <div class="profile-page-user-block">
    <form class="profile-page-user-form">
      <custom-input
        inputType="text"
        placeholder="Введите фамилию"
        labelText="Фамилия"
        v-model="userData.last_name"
        :errorMessage="validationErrors['last_name']"
        @keydown.enter.prevent="handleFormSubmit"
        :inputValue="userData.last_name"
        required
      />

      <main-select
        label="Страна"
        id="profile-country"
        v-model="userData.country"
        :options="countriesOptions"
        placeholder="Выберите страну"
        :clearable="false"
        :errorMessage="validationErrors['blockingUpClass']"
      />

      <custom-input
        inputType="text"
        placeholder="Введите имя"
        labelText="Имя"
        v-model="userData.name"
        :errorMessage="validationErrors['name']"
        @keydown.enter.prevent="handleFormSubmit"
        :inputValue="userData.name"
        required
      />

      <custom-input
        inputType="text"
        placeholder="Введите название организации"
        labelText="Организация"
        v-model="userData.organization"
        :errorMessage="validationErrors['organization']"
        @keydown.enter.prevent="handleFormSubmit"
        :inputValue="userData.organization"
      />

      <custom-input
        inputType="text"
        placeholder="Введите отчество"
        labelText="Отчество"
        v-model="userData.second_name"
        :errorMessage="validationErrors['second_name']"
        @keydown.enter.prevent="handleFormSubmit"
        :inputValue="userData.second_name"
      />

      <custom-input
        inputType="text"
        placeholder="Введите рабочий адрес"
        labelText="Адрес"
        v-model="userData.location"
        :errorMessage="validationErrors['location']"
        @keydown.enter.prevent="handleFormSubmit"
        :inputValue="userData.location"
      />

      <div class="profile-page-form-item">
        <label class="profile-page-form-label" for="profile-birthday">Дата рождения</label>
        <date-picker
          :class="[
            'profile-page-date-picker',

            { 'profile-page-date-picker_invalid': Boolean(validationErrors['birthday']) },
          ]"
          placeholder="__.__.____"
          id="profile-birthday"
          v-model="userData.birthday"
          :first-day-of-week="1"
          lang="ru"
          :editable="false"
        />
        <span style="display: block" class="invalid-feedback" v-show="validationErrors['birthday']">{{
          validationErrors["birthday"]
        }}</span>
      </div>

      <custom-input
        inputType="text"
        placeholder="Введите должность"
        labelText="Должность"
        v-model="userData.position"
        :errorMessage="validationErrors['position']"
        @keydown.enter.prevent="handleFormSubmit"
        :inputValue="userData.position"
      />
      <main-button
        :loading="loading"
        @click="handleFormSubmit"
        type="button"
        class="profile-page-form-button"
        color="secondary-fill"
        >Сохранить</main-button
      >
    </form>
  </div>
</template>

<script>
import MainButton from "./ui/MainButton.vue";
import Input from "./ui/Input.vue";
import DatePicker from "vue2-datepicker";
import MainSelect from "./ui/MainSelect.vue";
import { COUNTRIES } from "../constants/constants";

export default {
  data() {
    return {
      userData: {},
      validationErrors: {},
      countriesOptions: COUNTRIES,
      lengthError: "Значение не должно превышать 40 знаков",
      requiredError: "Необходимо заполнить поле",
      lengthValidationFields: ["last_name", "second_name", "name"],
      requiredFields: ["last_name", "name"],
      loading: false,
    };
  },
  components: { "custom-input": Input, MainSelect, DatePicker, MainButton },
  methods: {
    fetchUserData() {
      this.$http
        .get("profile/get", {
          params: {
            user_id: this.$auth.user().id,
          },
        })
        .then((response) => {
          this.userData = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },

    formValidate() {
      if (this.userData.birthday) {
        const birthdayDate = new Date(this.userData.birthday);
        const currentDate = new Date();
        if (birthdayDate > currentDate || currentDate.getFullYear() - birthdayDate.getFullYear() > 100) {
          this.validationErrors["birthday"] = "Поле заполнено некорректно";
        }
      }

      this.lengthValidationFields.forEach((field) => {
        if (this.userData[field].length > 40) {
          this.validationErrors[field] = this.lengthError;
        }
      });

      this.requiredFields.forEach((field) => {
        if (!this.userData[field].trim()) {
          this.validationErrors[field] = this.requiredError;
        }
      });
    },

    handleFormSubmit() {
      this.validationErrors = {};

      this.formValidate();

      if (Object.keys(this.validationErrors).length) {
        return;
      }

      this.loading = true;

      this.$http
        .put("profile/update?id=" + this.$auth.user().id, {
          Profile: { ...this.userData, country: this.userData.country ? this.userData.country.label : null },
        })
        .then((response) => {
          if (response.data.validationErrors) {
            this.validationErrors = [];
            for (const prop in response.data.validationErrors) {
              const key = prop.replace("profile-", "");
              this.validationErrors[key] = response.data.validationErrors[prop][0];
            }
          } else {
            this.$auth.user().profile.name = this.userData.name;
            this.$auth.user().profile.second_name = this.userData.second_name;
            this.$auth.user().profile.last_name = this.userData.last_name;
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  created() {
    this.fetchUserData();
  },
};
</script>

<style scoped>
.profile-page-user-block {
  margin-top: 32px;
}
.profile-page-user-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 32px;
}

.profile-page-date-picker {
  width: 300px;
}
@media screen and (max-width: 768px) {
  .profile-page-date-picker {
    width: 100%;
  }
}

.profile-page-form-label {
  display: block;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 4px;
  color: var(--black-color);
}
.profile-page-form-button {
  width: max-content;
  margin-top: 32px;
}
</style>
